import { Component, OnInit, OnDestroy } from '@angular/core';
import { IPlatformToolComponent, IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { Subject, Observable } from 'rxjs';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { DynamicFieldItem } from '@shared/components/dynamic-form/dynamic-form-item';
import { Router, ActivatedRoute } from '@angular/router';
import { CommandService } from '@core/services/command.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { DetailsInstructionService } from '@shared/services/details-instruction-service';
import { DialogService } from '@shared/services/dialog-service';
import { Store, select } from '@ngrx/store';
import { CollaborationState } from '@features/task-manager/collaboration/store/collaboration.reducer';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';
import { takeUntil, skip } from 'rxjs/operators';
import { SyncProjectEntityToCompanyCommand, UpdateArrangementCommand, CreateMonthlyFilingCommand, CreateQuarterlyFilingCommand, MarkAnnualFilingCommand } from '@features/dac6-reporter/commands/dac6-reporter.command';
import { Configuration } from '@shared/models/configuration';
import { Dac6FieldConfigKeys, SourceTypes, FieldefinitionDataType, BasketId } from '@features/dac6-reporter/Fields';
import { getQueryResponse } from '@shared/store/selectors/query.selector';
import { SetActivityFeedAction } from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import { QueryProvider } from '@shared/queries/query-provider';
import { PlatformCommand, ContentScope, PlatformCommandResponse } from '@shared/commands/command-base';
import { Guid } from 'guid-typescript';
import { BasketProvider } from '@shared/models/basket-provider';
import { CreateChatConversationCommand } from '@features/task-manager/collaboration/store/collaboration.command';
import { CreateChatConversationAction } from '@features/task-manager/collaboration/store/collaboration.action';
import { ConversationComponentName } from '@features/task-manager/collaboration/store/collaboration.constants';
import { DialogModel } from '@shared/models/dialog.model';


@Component({
    standalone: false,
    selector: 'particle-arrangement-detail-platform-container',
  templateUrl: './arrangement-detail-platform-container.component.html',
  styleUrls: ['./arrangement-detail-platform-container.component.scss']
})
export class ArrangementDetailPlatformContainerComponent implements OnInit, OnDestroy,IPlatformToolComponent {
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;

  id: any;
  ngUnsubscribe$ = new Subject<void>();
  item$: Observable<any>;
  sourceType: string;
  showDelete: boolean;
  item: any;
  endpointName: string;
  isProjectSpecific: boolean;
  showOriginal: boolean;
  invalidateSubject: InvalidateSubject  = new InvalidateSubject();
  showLanguageOption: boolean;
  autoSave: boolean;
  isDirty: boolean;
  toogled: boolean;
  editedFields: string[] = [];
  totalChanges: number = 0;
  autoSaveInterval;
  formField: DynamicFieldItem;
  fieldConfig: any;
  selectedSectionHearderKey : string;
  isAutoTagRefresh: boolean;
  changedValuesFieldDefination = [];
  constructor(private router: Router,
    protected activatedRoute: ActivatedRoute,
    private commandService: CommandService,
    private snackBarService: SnackBarService,
    private detailsInstructionService: DetailsInstructionService,
    private dialogService: DialogService,
    private collaborationStore: Store<CollaborationState>,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private queryState: Store<IQueryState>,
    private fileStoreCommonService: FileStoreCommonService) {
      this.sourceType = 'Arrangement';
      this.endpointName = 'Dac6Api';
      this.isProjectSpecific = false;
      this.showOriginal = false;
      this.showLanguageOption = false;
      this.invalidateSubject = new InvalidateSubject();
      this.autoSave = false;
      this.selectedSectionHearderKey = '';
    }

    ngOnInit() {
      this.invalidateSubject.getObservale().pipe(takeUntil(this.ngUnsubscribe$)).subscribe((state: any) => {
        if (state.indexOf('SaveChangesOnPageChangeOrTab') >= 0) {
          if(this.editedFields.length > 0)this.save();
        }
      });
      this.isDirty = true;
      this.toogled = true;
      const command = new SyncProjectEntityToCompanyCommand(false);
      this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(commandState => {
        console.log(commandState);
      });
      this.id = this.magicLinkModel.fieldValues['ArrangementId'];
      this.trackArrangementViewActivity(this.id);
      const config = Configuration.getSmartGridConfig(Dac6FieldConfigKeys.ArrangmentAEFieldConfigKey);
      config.Parameters['ID'] = this.id;
      this.item$ = this.queryState.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, 'ArrangementRowById'));
      this.item$.pipe(skip(1),takeUntil(this.ngUnsubscribe$)).subscribe((state: any) => {
        if (this.isAutoTagRefresh) {
          this.isAutoTagRefresh = false;
          this.autoTagRefresh(state);
          return;
        }
        const item = state.item;
        if (item && item.cells) {
          if (!this.item) {
            this.item = item;
            this.magicLinkModel.fieldValues['item'] = this.item;
          }
         // this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', id: this.item.cells['ReferenceCode'].value, title: this.item.cells['CaseId'].value, isDefault: false, isUserAction: false}));
          this.formField = state.formField;
          this.fieldConfig = state.fieldConfig;
          Object.keys(item.cells).forEach(key => {
            if (!this.item.cells[key]) {
              this.item.cells[key] = {};
            }
            this.item.cells[key].isDirty = false;
            this.item.cells[key].actualValue = item.cells[key].value;
            this.item.cells[key].value = item.cells[key].value;
            this.item.cells[key].displayText = item.cells[key].displayText;
          });

        }
        this.editedFields.splice(0, this.editedFields.length);
      });
      QueryProvider.invokeQuery(this.queryState, 'ArrangementRowById', {'[ID]': this.id});

      this.autoSaveInterval = setInterval( () => {
        if (this.isDirty && this.autoSave) {
          this.save();
        }
      }, 30000);
    }
  async canDeactivate() {
    let res = true;
    if(this.editedFields.length > 0){
      const question = 'You have unsaved changes. Do you want to save these changes before continuing?';
      const dialogRef = this.dialogService.showConfirmDialog('Unsaved Changes', 'Yes', 'No', null, question);
      dialogRef.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
        if (data.action === 'OK') {
          this.save();
          res = false;
        }
        else if(data.action === 'Closed'){
          res = false;
        }
      });
      await dialogRef.toPromise();
    }
    return res;
  }
  trackArrangementViewActivity(id: string){
    const command = new PlatformCommand('TrackArrangementViewCommand','DAC6Api');
    command.fieldValues['Id'] = id;
    command.fieldValues['SourceType'] = SourceTypes.Arrangement;
    this.commandService.executePlatformCommand(command).subscribe((response: any)=>{
      console.log(response);
    })
  }
  ngOnDestroy(): void {
    if (this.autoSaveInterval) {
      clearInterval(this.autoSaveInterval);
    }
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onValueChanged(event) {
    if (event && event.action === 'ApplyTagsSuccess') {
      this.isAutoTagRefresh = true;
      QueryProvider.invokeQuery(this.queryState, 'ArrangementRowById', {'[ID]': this.id});
      this.invalidateSubject.invalidate('Refresh|' + Guid.create().toString());
      return;
    }
    const exist = this.changedValuesFieldDefination.find( o => o.key === event.event.fieldDefinition.key);
    if (!exist) {
      this.changedValuesFieldDefination.push(event.event.fieldDefinition);
    }
    if (event) {
      switch (event.action) {
        case 'ValueChanged':
          this.totalChanges += event.increment;
          this.dirtyChanged('ENABLE');
          if (this.toogled) {this.toogled = false; }
          break;
        case 'Edit':
          this.save();
          break;
      }
    }
  }

  private dirtyChanged(action) {
    switch (action) {
      case 'ENABLE':
        if (!this.toogled) {
          this.isDirty = false;
          this.toogled = true;
        }
        break;
      case 'DISABLE':
        if (!this.toogled) {
          this.isDirty = false;
          this.toogled = true;
        }
        break;
    }
  }

  save(): void {
      if (this.editedFields.length) {
        const item = {};
        item['id'] = this.item.id;
        item['fieldValues'] = {};
        this.editedFields.forEach(fieldKey => {
          if (this.item.cells[fieldKey]) {
            item['fieldValues'][fieldKey] = this.item.cells[fieldKey].value;
            const fieldDef = this.changedValuesFieldDefination.find( o => o.key === fieldKey);
            if (fieldDef && fieldDef.dataType === FieldefinitionDataType.Attachment && this.item.cells['fileName']) {
              item['fieldValues'][`${fieldKey}FileName`] = this.item.cells['fileName'];
            }
          }
        });
        const command = new UpdateArrangementCommand(item);
        const currentBasket = BasketProvider.getCurrentBasket();
        switch (currentBasket.id){
          case BasketId.Mexico:
            command.IsHallmarkAutomatedCopy = true;
            break;
          default:
        }
        this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(commandState => {
          // this.snackBarService.showInformation('Arrangement Data Saved');
          QueryProvider.invokeQuery(this.queryState, 'ArrangementRowById', {'[ID]': this.id});
          this.totalChanges = 0;
          this.dirtyChanged('DISABLE');
          this.toogled = false;
          this.invalidateSubject.invalidate('SaveChanges|Refresh|' + Guid.create().toString());
        });
      } else { this.invalidateSubject.invalidate('SaveChanges|Refresh|' + Guid.create().toString()); }
  }

  autoSaveChanged(): void {
    if (!this.autoSave) {
      this.save();
    }
  }

  autosave () {
    // fixing build error
  }
  createMonthlyFiling() {
    const command = new CreateMonthlyFilingCommand(this.id, '', '', {});
    this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      if (state) {
        this.router.navigateByUrl('dac6-reporter/filing/monthly');
      }
    });
  }

  createQuarterlyFiling() {
    const command = new CreateQuarterlyFilingCommand(this.id, '', '', {});
    this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      if (state) {
        this.router.navigateByUrl('dac6-reporter/filing/quarterly');
      }
    });
  }

  markAnnualFiling() {
    const command = new MarkAnnualFilingCommand(this.id);
    this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      this.invalidateSubject.invalidate();
    });
  }

  navigateToCaseFolder() {
    let relativePath = 'DAC6 Reporter/[CASE_ID]/Arrangements';
    const caseId = this.item.cells['CaseId'].value;
    relativePath = relativePath.replace('[CASE_ID]', caseId);
    // const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath'))
    //   .pipe(take(2));
    // relativeUrl$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(state => {
    //   console.log('RelativeUrl', state);
    //   if (state) {
    //     this.router.navigateByUrl(state);
    //   }
    // });

    // QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});
    this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);
  }

  openConversation() {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: this.item.cells['CaseGUID'].value,
        caseId: this.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${this.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      this.item.cells['CaseGUID'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  openHallmarkTagging() {
    const dialogueModel = DialogModel.create('Hallmark Tagging', 'HallmarkTagSuggestionDialogComponent', {'Id':this.id});
    dialogueModel.maxWidth = '600px';
    dialogueModel.minWidth = '600px';
    this.dialogService.showOkCancelDialog(dialogueModel).subscribe(res => {
      if (res.data.action === 'nevigateToHallmark') {
        //this.formField.children[1].children[1].isExpanded = true;
        //this.invalidateSubject.invalidate('Refresh|' + Guid.create().toString());
        //this.router.navigateByUrl(`dac6-reporter/arrangement/c10bc2e0-6512-4f5e-8170-04492b6f597f`,{queryParams: {category: res.data.category, key: res.data.key}} );
      }
    });
  }
  selectedSectionIndexChange($event){
    this.selectedSectionHearderKey = $event;
    if(this.hasHallmarkTagging()){
      this.magicLinkModel.breadcrumbBar.items[0].commands[0].isDisabled = false;
    } else {
      this.magicLinkModel.breadcrumbBar.items[0].commands[0].isDisabled = true;
    }
  }
  hasHallmarkTagging(){
    const currentBasket = Configuration.getCurrentBasket();
    if(currentBasket){
      return currentBasket.basketKey === '' && this.selectedSectionHearderKey.toLowerCase().includes('_hallmarktagging');
    }
    return this.selectedSectionHearderKey.toLowerCase().includes('_hallmarktagging');
  }

  private autoTagRefresh(state: any) {
    if (!this.item.cells['Suggested_Hallmarks']) {
      this.item.cells['Suggested_Hallmarks'] = {};
    }
    if (!this.item.cells['ApplyTags']) {
      this.item.cells['ApplyTags'] = {};
    }
    if (state.item.cells['Suggested_Hallmarks'] && state.item.cells['Suggested_Hallmarks'].value) {
      this.item.cells['Suggested_Hallmarks'].isDirty = false;
      this.item.cells['Suggested_Hallmarks'].actualValue = state.item.cells['Suggested_Hallmarks'].value;
      this.item.cells['Suggested_Hallmarks'].value = state.item.cells['Suggested_Hallmarks'].value;
      this.item.cells['Suggested_Hallmarks'].displayText = state.item.cells['Suggested_Hallmarks'].displayText;
    }
    if (state.item.cells['ApplyTags'] && state.item.cells['ApplyTags'].value) {
      this.item.cells['ApplyTags'].isDirty = false;
      this.item.cells['ApplyTags'].actualValue = state.item.cells['ApplyTags'].value;
      this.item.cells['ApplyTags'].value = state.item.cells['ApplyTags'].value;
      this.item.cells['ApplyTags'].displayText = state.item.cells['ApplyTags'].displayText;
    }
  }
  onFieldSelectionChanged(event){
    if(event.metaData && event.metaData['DirectoryPath']){
      const caseId = this.item.cells['CaseId'].value;
      event.metaData['DirectoryPath'] = event.metaData['DirectoryPath'].replace('[CASE_ID]' ,caseId );
    }
    const currentSourceType = BasketProvider.getBasketMappedSourceType(SourceTypes.Arrangement);
    this.detailsInstructionService.openFieldDefinitionFieldDetial(event, currentSourceType);
  }

  onLoad() {
    throw new Error("Method not implemented.");
  }
  onBeforeExecuteNextCommand(): boolean {
    throw new Error("Method not implemented.");
  }
  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
    throw new Error("Method not implemented.");
  }
  onBeforeExecutePreviousCommand(): boolean {
    throw new Error("Method not implemented.");
  }
  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
    throw new Error("Method not implemented.");
  }
}
